import React,{useState} from 'react'
import Footer from "../inc/Footer";
import axios from "axios";
import "../inc/GlobalVars";
import Loader from '../inc/Loader';
function PayOnline() {

    const[loading,setLoading] = useState(false);
  return (
    <div>

{loading ? ( <Loader /> ) : (
<>
<div className='container'>
<div className="row">
            <div className="col-md-12 mb-5  mt-5 pt-5">
              <h1 style={{textTransform:"capitalize"}}>Pay Online</h1>
            </div>
          </div>
<div className='container'>
    <div className='row'>
        <div className='col-md-6'>
            <h4>Fees And Payments</h4>
            <table className='table table-bordered table-striped'>
                <thead>
                    <tr>
                        <th>Registration Fees</th>
                        <th>Security Deposit</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>(Non Refundable)</td>
                        <td>(Refundable)</td>
                    </tr>
                    <tr>
                        <td>₹ 9,440/-</td>
                        <td>₹ 20,000/-</td>
                    </tr>
                </tbody>
            </table>

            <table className='table table-bordered table-striped'>
                <thead>
                    <tr>
                        <th>Vehicle/Auction Fee</th>
                        <th>(Without Security Deposit)</th>
                        <th>(With Security Deposit)</th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                <td>
                For Value between ₹ 1,000 to ₹ 10 Lacs
                </td>
                <td>
                4% or ₹ 1,000*
                </td>
                <td>
                3% or ₹ 1,000*
                </td>
                </tr>
                <tr>
                <td>
                For Value above ₹ 10 Lacs
                </td>
                <td>
                2% or ₹ 1,000*
                </td>
                <td>
                1.5% or ₹ 1,000*
                </td>
                </tr>
                <tr>
                <td colspan="3" valign="top">
                * whichever is highest out of two
                </td>
                </tr>
                </tbody>
            </table>


            <table className='table table-bordered table-striped'>
                <thead>
                    <tr>
                        <th>Financial Details:</th>
                        
                    </tr>
                </thead>
                <tbody>
                <tr>
<td>
Bank Name:
</td>
<td>
HDFC
</td>
</tr>
<tr>
<td>
Account Name:
</td>
<td>
Indus Salvage Pvt Ltd
</td>
</tr>
<tr>
<td>
Account Number:
</td>
<td>
50200058244740
</td>
</tr>
<tr>
<td>
IFSC Code:
</td>
<td>
HDFC0000090
</td>
</tr>
<tr>
<td>
Branch Address:
</td>
<td>
GURUGRAM, SECTOR 14
</td>
</tr>
                </tbody>
            </table>
        </div>

        <div className='col-md-6'>
        <img src={window.location.origin + '/images/Indus-QR.jpg'} className="img-fluid" />
        </div>
    </div>
</div>
    </div>
    <Footer />
</> )}
    </div>
  )
}

export default PayOnline